// src/pages/container_rental/components/TotalRoundsField.tsx

import { Box, Chip, TextField, Typography } from "@mui/material";

interface TotalRoundsFieldProps {
  value: number | "";
  onChange: (v: number | "") => void;
  error?: boolean;
  helperText?: string;
}

const COMMON_TOTALS = [12, 24, 25, 36];

export default function TotalRoundsField({
  value,
  onChange,
  error,
  helperText,
}: TotalRoundsFieldProps) {
  return (
    <Box>
      <TextField
        label="총 회차"
        type="number"
        value={value === "" || value == null ? "" : value}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === "" ? "" : Math.max(1, Math.floor(Number(v))));
        }}
        inputProps={{ min: 1 }}
        fullWidth
        error={error}
        helperText={helperText}
      />
      <Box sx={{ mt: 0.75, display: "flex", alignItems: "center", gap: 0.75, flexWrap: "wrap" }}>
        <Typography variant="caption" color="text.secondary">자주 쓰는 값:</Typography>
        {COMMON_TOTALS.map((m) => (
          <Chip
            key={m}
            label={`${m}회차`}
            size="small"
            variant={value === m ? "filled" : "outlined"}
            color={value === m ? "primary" : "default"}
            onClick={() => onChange(m)}
            clickable
          />
        ))}
      </Box>
    </Box>
  );
}
